import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { images } from "../../assets/images";
import OTPInput from "react-otp-input";

const ForgotOTP = () => {
  const navigate = useNavigate();
  const [otp, setOtp] = useState("");

  return (
    <section className="login-section-bg">
      <div className="container-main d-flex flex-column justify-content-center">
        <div className="d-flex justify-content-center">
          <div className="auth-logo">
            <img
              src={images.pureTouchLogo}
              alt="app-logo"
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = images.appLogo;
              }}
            />
          </div>
        </div>

        <div className="card auth-card mb-5">
          <h5 className="mb-4 text-center text-primary fw-semibold">
            Verify OTP
          </h5>

          <form
            className="login-form"
            onSubmit={(e) => {
              e.preventDefault();
            }}
          >
            <div className="d-flex align-items-center justify-content-between mb-2">
              <p className="mb-0 fw-medium">johndoe@mailinator.com</p>
              <button
                className="btn btn-outline-primary d-flex align-items-center gap-2 py-1"
                onClick={() => {
                  navigate("/forgot-password");
                }}
              >
                <i className="fa-solid fa-pencil fa-sm"></i>Change
              </button>
            </div>
            <p>Enter the OTP we sent to your email.</p>
            <div className="mt-3 text-center d-flex justify-content-center">
              <OTPInput
                value={otp}
                onChange={setOtp}
                numInputs={6}
                inputType="tel"
                renderSeparator={<span> </span>}
                renderInput={(props) => (
                  <input {...props} className="otp-input" />
                )}
              />
            </div>
            <div className="mt-4 text-center">
              <button
                type="submit"
                className="btn btn-primary mt-2"
                onClick={() => {
                  navigate("/reset-pass");
                }}
              >
                Verify
              </button>
            </div>
            <div className="d-flex align-items-center justify-content-center mt-4 gap-1">
              <p className="mb-0 text-muted">Don’t receive OTP?</p>
              <p className="mb-0 text-primary cursor-pointer">Resend OTP</p>
            </div>
          </form>
        </div>
      </div>
    </section>
  );
};

export default ForgotOTP;
